import { render } from "./page1_Step1_help.vue?vue&type=template&id=01288a05"
import script from "./page1_Step1_help.vue?vue&type=script&lang=js"
export * from "./page1_Step1_help.vue?vue&type=script&lang=js"

import "./page1_Step1_help.vue?vue&type=style&index=0&id=01288a05&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__